<template>
    <v-container class="container" fluid>
        <v-toolbar dense dark color="secondary">
            <v-spacer></v-spacer>
            <v-toolbar-title class="white--text">Fuel</v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card class="mb-5">
            <v-form ref="formDates" v-model="valid" lazy-validation>
                <v-container fluid>
                    <v-row class="justify-center">
                        <v-col sm="6" md="4" lg="5">
                            <v-text-field id="startDate" :value="startDate" required label="Start Date"
                                :placeholder="$store.state.placeholder" v-mask="$store.state.mask"
                                :rules="$store.state.dateRules"></v-text-field>
                        </v-col>
                        <v-col sm="6" md="4" lg="5">
                            <v-text-field id="endDate" :value="endDate" label="End Date" required
                                :placeholder="$store.state.placeholder" v-mask="$store.state.mask"
                                :rules="$store.state.dateRules"></v-text-field>
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
            <v-row class="justify-center mb-1">
                <v-btn @click="validateFormDates('checkStatements')" exact dark color="primary" class="mx-1  white--text">
                    Check Statements
                </v-btn>
                <v-btn @click="validateFormDates('Uncharged')" exact dark color="primary" class="mx-1  white--text">
                    Uncharged Fuel
                </v-btn>
                <v-btn @click="validateFormDates('Statements Report')" exact dark color="primary" class="mx-1  white--text">
                    Statements Report
                </v-btn>
                <v-btn @click="validateFormDates('IFTA')" exact dark color="primary" class="mx-1  white--text">
                    IFTA
                </v-btn>
            </v-row>
            <v-row class="justify-center">

            </v-row>
            <v-form ref="formSearch" lazy-validation>
                <v-row class="justify-center">
                    <v-col cols="2">
                        <v-btn 
                        @click="toNewEntry"
                        exact dark color="primary" class="mr-  white--text">
                    Expenses Entry
                </v-btn>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="6">
                        <v-select v-model="searchSelect" :items="searchOptions" :item-text="searchOptions.text"
                            :item-value="searchOptions.value" label="Search by" dense :rules="[v => !!v || 'Required']"
                            class="mt-5" return-object></v-select>
                    </v-col>
                    <v-col sm="3" cols="6">
                        <v-text-field v-model="searchTextField" :label="searchSelect.text"
                            :rules="[v => !!v || 'Required']"></v-text-field>
                    </v-col>
                    <v-col cols="1">
                        <v-btn @click="validateFormSearch()" exact dark small color="primary" class="mt-6 white--text">
                            <v-icon>mdi-magnify</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-btn to="/Administration/fuel/fuel-statement" exact dark color="primary"
                            class="mx-1 white--text">
                            Post fuel Statement
                        </v-btn>
                    </v-col>
                </v-row>

            </v-form>
        </v-card>
        <uncharged v-if="$store.state.payroll.modalUncharged"></uncharged>
        <statementRp v-if="$store.state.payroll.statementRp"></statementRp>
        <ifta v-if="$store.state.payroll.ifta"></ifta>
    </v-container>
</template>

<script>
import { mask } from 'vue-the-mask';
import uncharged from './../Modals/Administration/Fuel/Uncharged.vue';
import statementRp from './../Modals/Administration/Fuel/StatementsReport.vue';
import ifta from './../Modals/Administration/Fuel/IftaReport.vue';
export default {
    name: 'Fuel',
    directives: {
        mask
    },
    components: {
        uncharged,
        statementRp,
        ifta,
    },
    data: function () {
        return {
            startDate: null,
            endDate: null,
            searchOptions: [
                {
                    text: 'Supplier Invoice No.',
                    value: 1
                },
                {
                    text: 'Stmt PayId',
                    value: 2
                }
            ],
            searchSelect: '',
            searchTextField: '',
            valid: false
        };
    },

    mounted() {
            this.startDate = this.$store.state.checkStatements.start_date;
            this.endDate = this.$store.state.checkStatements.end_date;
    },
    methods: {
        toNewEntry: function(){
            this.$store.state.expensesEntries.start_date = this.$store.state.getMsk(
                'startDate'
            );
            this.$store.state.expensesEntries.end_date = this.$store.state.getMsk(
                'endDate'
            );
            this.$store.state.checkStatements.start_date = this.$store.state.getMsk(
                'startDate'
            );
            this.$store.state.checkStatements.end_date = this.$store.state.getMsk(
                'endDate'
            );
            this.$router.push('/administration/fuel/expenses-entries');
        },
        toExpensesEntries: function () {
            this.$store.state.expensesEntries.start_date = this.$store.state.getMsk(
                'startDate'
            );
            this.$store.state.expensesEntries.end_date = this.$store.state.getMsk(
                'endDate'
            );
            this.$store.state.checkStatements.start_date = this.$store.state.getMsk(
                'startDate'
            );
            this.$store.state.checkStatements.end_date = this.$store.state.getMsk(
                'endDate'
            );
            this.$router.push('/Administration/fuel/expenses-entries');
        },
        toCheckStatements: function () {
            this.$store.state.checkStatements.start_date = this.$store.state.getMsk(
                'startDate'
            );
            this.$store.state.checkStatements.end_date = this.$store.state.getMsk(
                'endDate'
            );
            console.log(
                this.$store.state.checkStatements.start_date,
                this.$store.state.checkStatements.end_date
            );
            this.$router.push('/Administration/fuel/check-statements');
        },
        search: function () {
            this.$store.state.viewFuelStatements.from = 'search';
            this.$store.state.searchFuelExpenseDetails.searchParameter = this.searchSelect;
            this.$store.state.searchFuelExpenseDetails.searchValue = this.searchTextField;

            this.$router.push('/Administration/fuel/view-fuel-statement');
        },
        validateFormSearch() {
            if (this.$refs.formSearch.validate()) {
                this.search();
            }
        },
        validateFormDates: function (redirectTo) {
            if (this.$refs.formDates.validate()) {
                if (redirectTo == 'expensesEntry') {
                     this.toExpensesEntries();
                } else if (redirectTo == 'checkStatements') {
                    this.toCheckStatements();
                } else if (redirectTo == 'Uncharged') {
                    this.$store.state.payroll.modalUncharged = true;
                    this.$store.state.payroll.StartDate = this.$store.state.getMsk(
                        'startDate'
                    );
                    this.$store.state.payroll.EndDate = this.$store.state.getMsk(
                        'endDate'
                    );
                }else if(redirectTo == 'Statements Report'){
                    this.$store.state.payroll.statementRp = true;
                    this.$store.state.payroll.StartDate = this.$store.state.getMsk(
                        'startDate'
                    );
                    this.$store.state.payroll.EndDate = this.$store.state.getMsk(
                        'endDate'
                    );
                }else if(redirectTo == 'IFTA'){
                    this.$store.state.payroll.ifta = true;
                    this.$store.state.payroll.StartDate = this.$store.state.getMsk(
                        'startDate'
                    );
                    this.$store.state.payroll.EndDate = this.$store.state.getMsk(
                        'endDate'
                    );
                }
            }
        }
    }
};
</script>
<style></style>
